/** Lógica de Facturación DCIC Group **/
function syncFacturaDCIC() {
  const check = document.getElementById('solicita-factura-check');
  const box = document.getElementById('seccion-factura-campos');
  
  if (check && box) {
    const isVisible = check.checked;
    const targetDisplay = isVisible ? 'flex' : 'none';
    
    if (box.style.display !== targetDisplay) {
      box.style.display = targetDisplay;
      box.querySelectorAll('input').forEach(i => i.required = isVisible);
    }
  }
}

function saveAttributesDCIC() {
  const box = document.getElementById('seccion-factura-campos');
  if (!box) return;
  
  const attributes = {};
  box.querySelectorAll('input').forEach(input => {
    const attrName = input.name.match(/attributes\[(.*?)\]/);
    if (attrName) attributes[attrName[1]] = input.value;
  });

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes })
  });
}

// Escucha global para asegurar captura en elementos dinámicos
document.addEventListener('click', function(e) {
  if (e.target && e.target.id === 'solicita-factura-check') {
    syncFacturaDCIC();
  }
});

let timeoutDCIC;
document.addEventListener('input', function(e) {
  if (e.target && e.target.name && e.target.name.includes('attributes')) {
    clearTimeout(timeoutDCIC);
    timeoutDCIC = setTimeout(saveAttributesDCIC, 800);
  }
});

// Intervalo de seguridad para componentes dinámicos de Shopify
setInterval(syncFacturaDCIC, 600);